import React from 'react';
import { Shield, CheckCircle, Lock, Award } from 'lucide-react';

const SecuritySection: React.FC = () => {
  const certifications = [
    {
      icon: <Shield className="w-8 h-8" />,
      title: 'HIPAA Certified',
      description: 'Fitzaa maintains Health Insurance Portability and Accountability Act certification, safeguarding your confidential health data with leading industry protocols.',
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: 'ISO 27001 & ISO 27701',
      description: 'Fitzaa holds certification under both International Organization for Standardization 27001 and ISO 27701 protocols.',
    },
    {
      icon: <Lock className="w-8 h-8" />,
      title: 'GDPR Compliant',
      description: 'Fitzaa adheres to General Data Protection Regulation requirements, guaranteeing personal information is managed with maximum security, openness, and reliability.',
    },
    {
      icon: <Award className="w-8 h-8" />,
      title: 'SOC II Certified',
      description: 'Our Service Organization Control II certification demonstrates Fitzaa\'s dedication to information protection.',
    },
  ];

  return (
    <section className="py-20 bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Protected by organizational-level security and scalability
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="p-6 bg-gradient-to-br from-purple-50 to-white dark:from-slate-800 dark:to-slate-900 rounded-xl shadow-md hover:shadow-lg transition-shadow border border-gray-200 dark:border-slate-700 text-center"
            >
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center">
                  <div className="text-purple-600 dark:text-purple-400">
                    {cert.icon}
                  </div>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                {cert.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
                {cert.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;

